import React from 'react'

import { Navbar, Footer } from '../../../components';
import { Article7Doc } from '../individual';

export default function Article7() {
  return (
    <div className='emas__article1'>
        <Navbar />
        <Article7Doc />
        <Footer />
    </div>
  )
}
